import React from "react";
import {FieldViewProps} from "../../../../render/view";
import FieldToggle_Component from "../components/toggle-stateless";
import {ToggleSize} from "../components/toggle-statefull";

// used in board

export default function FieldTToggle_ViewProperty(props: FieldViewProps) {


    const value = props.model[props.field.fieldId]

    return (
        <div className="flex-row-left-center m-r-8 m-b-5">
            <FieldToggle_Component size={ToggleSize.SIZE_16} value={value} disabled={props.field.isDisabled}/>
        </div>
    )

}
